import {createSlice} from "@reduxjs/toolkit";

const initialTransferState = {
  data: null,
  error: null,
};

export const transferSlice = createSlice({
  name: "transfer",
  initialState: initialTransferState,
  reducers: {
    fetchTransfer: (state, action) => {
      const {entities} = action.payload;
      state.error = null;
      state.data = entities;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
    },
    startCall: (state) => {
      state.error = null;
    },
  }
});
